import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Trend from "vuetrend";
import "bulma/css/bulma.min.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBolt,
  faFireAlt,
  faDollarSign,
  faTrophy,
  faHeartbeat,
  faShieldAlt
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
  faBolt,
  faFireAlt,
  faDollarSign,
  faTrophy,
  faHeartbeat,
  faShieldAlt
);

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(Trend);
Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
